class EncryptionService {
    // Convert text to ArrayBuffer
    static textToArrayBuffer(text) {
        return new TextEncoder().encode(text);
    }

    // Convert ArrayBuffer to text
    static arrayBufferToText(buffer) {
        return new TextDecoder().decode(buffer);
    }

    // Derive a cryptographic key from a string
    static async deriveKeyFromString(keyString) {
        const keyMaterial = await crypto.subtle.importKey(
            "raw",
            this.textToArrayBuffer(keyString),
            { name: "PBKDF2" },
            false,
            ["deriveKey"]
        );
        return await crypto.subtle.deriveKey(
            {
                name: "PBKDF2",
                salt: this.textToArrayBuffer("7vhGRUpRvGIoRjYuEac8iRe7gAq3ahun"),
                iterations: 100000,
                hash: "SHA-256",
            },
            keyMaterial,
            { name: "AES-GCM", length: 256 },
            true,
            ["encrypt", "decrypt"]
        );
    }

    // Encrypt text with a custom key string
    static async encryptText(text, keyString) {
        const key = await this.deriveKeyFromString(keyString);
        const iv = crypto.getRandomValues(new Uint8Array(12)); // Initialization vector
        const encryptedData = await crypto.subtle.encrypt(
            {
                name: "AES-GCM",
                iv,
            },
            key,
            this.textToArrayBuffer(text)
        );
        // Prepend IV to the encrypted data
        const combined = new Uint8Array(iv.length + encryptedData.byteLength);
        combined.set(iv, 0);
        combined.set(new Uint8Array(encryptedData), iv.length);
        return btoa(String.fromCharCode(...combined)); // Base64 encode the combined result
    }

    // Decrypt text with a custom key string
    static async decryptText(encryptedWithIv, keyString) {
        const combined = new Uint8Array(atob(encryptedWithIv).split("").map(char => char.charCodeAt(0)));
        // Extract IV (first 12 bytes) and encrypted data (the rest)
        const iv = combined.slice(0, 12);
        const encryptedData = combined.slice(12);
        const key = await this.deriveKeyFromString(keyString);
        const decrypted = await crypto.subtle.decrypt(
            {
                name: "AES-GCM",
                iv,
            },
            key,
            encryptedData
        );
        return this.arrayBufferToText(decrypted);
    }

	// Synchronous wrapper function
	static encryptTextSync(text, keyString) {
		let result = '';
		EncryptionService.encryptText(text, keyString).then(encrypted => {
			result = encrypted;
		}).catch(err => {
			console.error('Encryption failed', err);
		});
		return result;
	}

	static decryptTextSync(encryptedText, keyString) {
		let result = '';
		EncryptionService.decryptText(encryptedText, keyString).then(decrypted => {
			result = decrypted;
		}).catch(err => {
			console.error('Decryption failed', err);
		});
		return result;
	}

}

export default EncryptionService;
